function addClientPage(client, store) {
  /* Create Indexes for Root Menu */

  let currentContext = JSON.parse(client.CurrentContext);
  let meetingObj = JSON.parse(client.MeetingContext);
  let initialContext = (client.InitialContext && JSON.parse(client.InitialContext)) || {};
  console.log('addClientPage', 'initialContext:', initialContext);

  store.addMeetingIndex(meetingObj.MeetingRootId);
  store.addMeetingIndex(meetingObj.MeetingParentId);

  let parentIndex = store.getMeetingIndex(meetingObj.MeetingRootId);
  let localIndex = store.getMeetingIndex(meetingObj.MeetingParentId);

  let rootMenuObj = {
    ParentIndex : parentIndex,
    LocalIndex : localIndex,
    MeetingRootDN : (meetingObj.MeetingName) ? meetingObj.MeetingName : meetingObj.MeetingRootDN,
    MeetingParentDN : (meetingObj.MeetingName) ? meetingObj.MeetingName : meetingObj.MeetingParentDN,
    PrettyURL : null,
    Path : meetingObj.MeetingRootId + '/' + meetingObj.MeetingParentId,
    LeftRole : client.ClientLeftRole,
    RightRole : client.ClientRightRole,
    LeftID : client.ClientLeft,
    RightID : client.ClientRight,
    LeftDN : client.ClientLeftDN,
    RightDN : client.ClientRightDN,
    DisplayStatus : null,
    ClientRowID : client.Client,
    PermanentLink : true,
    MeetingContext : meetingObj,
    Type : 'Parent',
    TerminationClasses: {  'viewer-role-enabled': client.ClientRightRole.toLowerCase() == 'visitor',
      'normal-enabled': client.ClientRightRole.toLowerCase() != 'visitor' },
    ClientClasses: { 'open-hidden': !!initialContext.openHidden }
  };

  store.addRootMenu(rootMenuObj);
  console.log("PullRootMenu currentContext : ", currentContext);
  window.BotServices.PullRootMenu(rootMenuObj);
}

function openClientPage(path, store) {
  if(path) {
    let rootMenuObj = store.getRootMenuByPath(path);
    if(rootMenuObj) {
      window.BotServices.PullRootMenu(rootMenuObj);
    }
  }
}

export {
  addClientPage,
  openClientPage
}
